import React from "react";
import SideMenu from "../../Components/SideMenu/SideMenu";
import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect,
  Switch,
  useLocation,
} from "react-router-dom";
import Budget from "../Budget/Budget";
import Reports from "../Reports/Reports";
import Home from "../Home/Home";
import Settings from "../Settings/Settings";
import Register from "../Register/Register";
import MenuButton from "../../Components/MenuButton/MenuButton";
import Login from "../Login/Login";
import ForgotPassword from "../ForgotPassword/ForgotPassword";
import ResetPassword from "../ResetPassword/ResetPassword";
import NotFound from "../NotFound/NotFound";
import Privacy from "../Privacy/Privacy";
import Support from "../Support/Support";
import DashboardPage from "../DashboardPage/DashboardPage";
import avatarIcon from "../../img/account_circle-24px.svg";
import API from "../../API/REST_API";
import { getCurrencySymbol } from "../../constants/currencies";

// Component to show page title on mobile (uses useLocation for reactive updates)
const MobilePageTitle = () => {
  const location = useLocation();
  const path = location.pathname;

  const getPageTitle = () => {
    if (path.startsWith("/budget")) return "Budget";
    if (path.startsWith("/reports")) return "Reports";
    if (path.startsWith("/settings")) return "Settings";
    if (path.startsWith("/dashboard")) return "Dashboard";
    return "Dashboard";
  };

  return <div className="text-base font-semibold md:hidden">{getPageTitle()}</div>;
};

// Wrapper so SideMenu receives current path from router (highlights correct item when navigating via avatar etc.)
const SideMenuWithPath = (props) => {
  const location = useLocation();
  return <SideMenu {...props} currentPath={location.pathname} />;
};
export default class DashBoard extends React.Component {
  state = {
    baseUrl: (() => {
      const envUrl = process.env.REACT_APP_API_URL;
      console.log("REACT_APP_API_URL from env:", envUrl);
      return envUrl || "http://localhost:5000";
    })(),
    apiRouts: {
      FETCH_BY_DATE: "/api/v1/expenses?from_date=",
      FETCH_BY_TYPE: "/api/v1/expenses?type=",
      CREATE_NEW_REC: "/api/v1/expenses",
      CATEGORIES: "/api/v1/categories",
      LOG_OUT: "/api/v1/auth/logout",
      REGISTER: "/api/v1/users",
      GET_PROFILE: "/api/v1/users/me",
      SETTINGS: "/api/v1/settings",
      REPORTS: "/api/v1/reports",
    },
    showMenu: false,
    sidebarCollapsed: false,
    authLoading: true,
    user: {
      avatar: "",
      first_name: "",
      last_name: "",
      logedIn: false,
      email: "",
      remove_enabled: false,
    },

    category: {
      income: {
        title: "Income",
        path: "/budget/income",
        data: [],
      },
      saving: {
        title: "Saving",
        path: "/budget/saving",
        data: [],
      },
      const_expense: {
        title: "Fixed Expenses",
        path: "/budget/fixedexpenses",
        data: [],
      },
      expense: {
        title: "Expenses",
        path: "/budget/expenses",
        data: [],
      },
    },
    settings: {
      currency: "",
      symbol: "",
    },
  };

  componentDidMount = async () => {
    // Set up session expiry handler - redirects to login when refresh token expires
    API.setSessionExpiredCallback(() => {
      console.log("Session expired, redirecting to login...");
      this.handleSessionExpired();
    });

    const currentPath = window.location.pathname;
    const isAuthPage = currentPath === "/login" || currentPath === "/register" || currentPath === "/forgot-password" || currentPath === "/reset-password";

    this.setState({ authLoading: true });
    if (!isAuthPage) {
      await this.user_loging_validate_handler();
      await this.loadSettings();
    } else {
      this.setState({ authLoading: false });
    }
    let elem = document.getElementsByClassName("dashboard-home");
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      /* Firefox */
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Chrome, Safari & Opera */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE/Edge */
      elem.msRequestFullscreen();
    }

  };

  handleSessionExpired = () => {
    const currentPath = window.location.pathname;
    if (currentPath === "/login" || currentPath === "/register" || currentPath === "/forgot-password" || currentPath === "/reset-password") {
      return;
    }

    // Clear local storage
    localStorage.removeItem("first_name");
    localStorage.removeItem("last_name");
    localStorage.removeItem("email");
    localStorage.removeItem("id");

    // Reset user state
    let user = JSON.parse(JSON.stringify(this.state.user));
    user.first_name = "";
    user.last_name = "";
    user.logedIn = false;
    user.avatar = avatarIcon;

    this.setState({ user });

    // Redirect to login
    window.location = "/login";
  };

  logout = async () => {
    let url = this.state.baseUrl + this.state.apiRouts["LOG_OUT"];

    try {
      await API.Post(url, {});
    } catch (error) {}

    localStorage.removeItem("first_name");
    localStorage.removeItem("last_name");
    localStorage.removeItem("email");
    localStorage.removeItem("id");

    let user = JSON.parse(JSON.stringify(this.state.user));
    user.first_name = "";
    user.last_name = "";
    user.logedIn = false;
    user.avatar = avatarIcon;

    this.setState({
      user,
    });
  };
  async user_loging_validate_handler() {
    let email = localStorage.getItem("email");
    let user_fetch = await this.getUserProfileHandler();

    let user = {
      avatar: avatarIcon,
      first_name: "",
      last_name: "",
      email,
      logedIn: false,
    };
    if (user_fetch) {
      user.first_name = user_fetch.first_name;
      user.last_name = user_fetch.last_name;
      user.remove_enabled = user_fetch.remove_enabled;
      user.email = user_fetch.email || email;
      user.logedIn = true;
    }
    this.setState({
      user,
      authLoading: false,
    });
  }

  renderRoutes = (className = "") => {
    const isLoggedIn = this.state.user.logedIn;
    return (
      <div className={`flex-1 min-h-0 flex flex-col overflow-x-hidden overflow-y-hidden md:overflow-y-auto ${className}`}>
        <Switch>
          <Route path="/login">
            <Login
              baseUrl={this.state.baseUrl}
              loginValidate={this.user_loging_validate_handler}
              user={this.state.user}
            ></Login>
          </Route>
          {!isLoggedIn && (
            <Route path="/register">
              <Register
                register_url={this.state.apiRouts.REGISTER}
                baseUrl={this.state.baseUrl}
              ></Register>
            </Route>
          )}
          <Route path="/forgot-password">
            <ForgotPassword baseUrl={this.state.baseUrl} />
          </Route>
          <Route path="/reset-password">
            <ResetPassword baseUrl={this.state.baseUrl} />
          </Route>
          <this.PrivateRoute exact path="/dashboard">
            <DashboardPage
              apiRouts={this.state.apiRouts}
              baseUrl={this.state.baseUrl}
              user={this.state.user}
            ></DashboardPage>
          </this.PrivateRoute>
          <this.PrivateRoute path="/budget">
            <Budget
              apiRouts={this.state.apiRouts}
              baseUrl={this.state.baseUrl}
              user={this.state.user}
              settings={this.state.settings}
            ></Budget>
          </this.PrivateRoute>

          <this.PrivateRoute path="/settings">
            <Settings
              get_profile={this.state.apiRouts.GET_PROFILE}
              apiRouts={this.state.apiRouts}
              update_profile_url={this.state.apiRouts.REGISTER}
              baseUrl={this.state.baseUrl}
              user={this.state.user}
              update_remove_enabled={this.update_remove_enabled}
              onSettingsUpdate={this.refreshSettings}
            ></Settings>
          </this.PrivateRoute>

          <this.PrivateRoute path="/reports">
            <Reports
              user={this.state.user}
              get_expenses={this.state.apiRouts.CREATE_NEW_REC}
              baseUrl={this.state.baseUrl}
              apiRouts={this.state.apiRouts}
              reportsUrl={this.state.apiRouts.REPORTS}
              settings={this.state.settings}
            ></Reports>
          </this.PrivateRoute>

          <Route exact path="/home">
            {isLoggedIn ? (
              <Redirect to="/dashboard" />
            ) : (
              <Home
                loginValidate={this.user_loging_validate_handler}
                user={this.state.user}
                baseUrl={this.state.baseUrl}
              ></Home>
            )}
          </Route>
          <Route exact path="/">
            {isLoggedIn ? (
              <Redirect to="/dashboard" />
            ) : (
              <Home 
                user={this.state.user}
                baseUrl={this.state.baseUrl}
                loginValidate={this.user_loging_validate_handler}
              ></Home>
            )}
          </Route>

          <Route path="/privacy">
            <Privacy />
          </Route>
          <Route path="/support">
            <Support />
          </Route>

          {/* 404 Not Found - must be last */}
          <Route path="*">
            <NotFound isLoggedIn={isLoggedIn} />
          </Route>
        </Switch>
      </div>
    );
  };

  render() {
    // Set avatar based on user state
    let avatar = (
      <img
        src={this.state.user.avatar || avatarIcon}
        alt=""
        className="h-8 w-8 md:h-9 md:w-9 rounded-full bg-slate-200 object-cover"
      />
    );

    if (this.state.user.last_name && this.state.user.first_name) {
      avatar = (
        <div className="flex h-8 w-8 md:h-9 md:w-9 items-center justify-center rounded-full bg-slate-200 text-xs md:text-sm font-semibold text-slate-700">
          {this.state.user.first_name.substr(0, 1) +
            this.state.user.last_name.substr(0, 1)}
        </div>
      );
    }

    const path = window.location.pathname || "";
    const hideNavForRoute =
      path.startsWith("/login") || path.startsWith("/register") || path.startsWith("/forgot-password") || path.startsWith("/reset-password") || path.startsWith("/privacy") || path.startsWith("/support");
    const showNav = !this.state.authLoading && this.state.user.logedIn && !hideNavForRoute;
    const contentPaddingClass = "";
    
    return (
      <div className="dashboard-home flex min-h-screen flex-col bg-slate-50 text-slate-900 md:h-screen overflow-x-hidden">
        <div className="mx-auto flex min-h-full w-full flex-col md:h-full xl:max-w-[70%] overflow-x-hidden">
        <Router>
          {/* Mobile header - fixed at top */}
          {showNav && (
            <header 
              className="fixed top-0 left-0 right-0 z-50 border-b border-slate-200 bg-white md:hidden"
              style={{ height: "50px" }}
            >
              <div className="flex h-full items-center justify-between px-4">
                <div className="flex items-center gap-3">
                  <MenuButton onClick={this.menuButton}></MenuButton>
                  <MobilePageTitle />
                </div>
                <div className="flex items-center gap-2">
                  <Link to="/settings" className="flex items-center justify-center">
                    {avatar}
                  </Link>
                </div>
              </div>
            </header>
          )}
          {/* Spacer for fixed header on mobile */}
          {showNav && <div className="h-[50px] flex-shrink-0 md:hidden"></div>}
          
          {/* Desktop header - in normal flow */}
          {showNav && (
            <header 
              className="hidden md:block z-50 border-b border-slate-200 bg-white flex-shrink-0"
              style={{ height: "50px" }}
            >
              <div className="flex h-full items-center justify-between px-4 md:px-6">
                <div className="flex items-center gap-3">
                  <MenuButton onClick={this.menuButton}></MenuButton>
                  <div className="text-lg font-semibold">Kakeibo</div>
                </div>
                <div className="flex items-center gap-2">
                  <Link to="/settings" className="flex items-center justify-center">
                    {avatar}
                  </Link>
                </div>
              </div>
            </header>
          )}
          <div className="flex flex-1 md:overflow-hidden">
            {showNav && (
              <>
                {/* Mobile sidebar - overlay with animation */}
                <div
                  className={`fixed inset-y-0 left-0 z-40 w-64 transform border-r border-slate-200 bg-white shadow-lg transition-transform duration-300 ease-in-out md:hidden ${
                    this.state.showMenu ? "translate-x-0" : "-translate-x-full"
                  }`}
                  style={{ top: "50px" }}
                >
                  <SideMenuWithPath
                    height="500"
                    collapsed={false}
                    OnSelectMenu={this.closeMenu}
                    onToggleCollapse={this.toggleSidebar}
                    onLogOutHandler={this.logout}
                  />
                </div>

                {/* Desktop sidebar - normal flow */}
                <div
                  className={`relative hidden border-r border-slate-200 bg-white shadow-lg transition-all duration-200 md:block ${
                    this.state.sidebarCollapsed ? "w-20" : "w-64"
                  }`}
                >
                  <SideMenuWithPath
                    height="500"
                    collapsed={this.state.sidebarCollapsed}
                    OnSelectMenu={this.closeMenu}
                    onToggleCollapse={this.toggleSidebar}
                    onLogOutHandler={this.logout}
                  />
                </div>

                {/* Mobile backdrop overlay with fade animation */}
                <div
                  className={`fixed inset-0 z-30 bg-black/30 transition-opacity duration-300 md:hidden ${
                    this.state.showMenu
                      ? "pointer-events-auto opacity-100"
                      : "pointer-events-none opacity-0"
                  }`}
                  style={{ top: "50px" }}
                  onClick={() => this.menuButton(false)}
                ></div>
              </>
            )}
            {this.renderRoutes(contentPaddingClass)}
          </div>
        </Router>
        </div>
      </div>
    );
  }
  closeMenu = () => {
    this.setState({ showMenu: false });
  };
  toggleSidebar = () => {
    this.setState((prev) => ({
      sidebarCollapsed: !prev.sidebarCollapsed,
    }));
  };
  menuButton = (isOn) => {
    const isDesktop =
      typeof window !== "undefined" && window.innerWidth >= 768;
    if (isDesktop) {
      this.setState((prev) => ({
        showMenu: true,
        sidebarCollapsed: !prev.sidebarCollapsed,
      }));
      return;
    }
    this.setState({
      showMenu: isOn === false ? false : !this.state.showMenu,
    });
  };
  PrivateRoute = ({ children, ...rest }) => {
    if (this.state.authLoading) {
      return null;
    }

    if (this.state.user.logedIn) {
      return <Route {...rest} render={({ location }) => children}></Route>;
    } else {
      return (
        <Route
          {...rest}
          render={({ location }) => (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: location },
              }}
            />
          )}
        ></Route>
      );
    }
  };

  getUserProfileHandler = async () => {
    const updateURL = this.state.baseUrl + this.state.apiRouts.GET_PROFILE;
    try {
      const result = await API.Get(updateURL);
      return result;
    } catch (error) {
      console.error("Error fetching user profile:", error);
      return null;
    }
  };

  loadSettings = async () => {
    if (!this.state.user.logedIn) return;
    
    try {
      const settingsURL = this.state.baseUrl + this.state.apiRouts.SETTINGS;
      const settings = await API.Get(settingsURL);
      
      // Clean up settings object
      const cleanedSettings = { ...settings };
      delete cleanedSettings.createdAt;
      delete cleanedSettings.owner;
      delete cleanedSettings.updatedAt;
      delete cleanedSettings.__v;
      delete cleanedSettings.id;
      
      // Derive symbol from currency code (handles legacy "CODE-SYMBOL" format)
      const currencyCode = cleanedSettings.currency?.includes("-")
        ? cleanedSettings.currency.split("-")[0]
        : cleanedSettings.currency;
      cleanedSettings.currency = currencyCode;
      cleanedSettings.symbol = currencyCode ? getCurrencySymbol(currencyCode) : "";
      
      this.setState({
        settings: cleanedSettings,
      });
    } catch (error) {
      console.error("Error loading settings:", error);
    }
  };

  refreshSettings = async () => {
    await this.loadSettings();
  };

  update_remove_enabled = async (remove_enabled) => {
    const updateURL = this.state.baseUrl + this.state.apiRouts.REGISTER;

    const body = {
      remove_enabled,
    };

    try {
      const { response, data } = await API.Patch(updateURL, body);

      if (response && response.ok) {
        let user = JSON.parse(JSON.stringify(this.state.user));
        user.remove_enabled = data.remove_enabled;

        this.setState({ user });
      }

      if (response.status === 400) {
        throw new Error("something went wrong , please try again later");
      }
    } catch (error) {
      this.setState({
        personal_details_error: "*" + error,
        personal_update: false,
      });
    }
  };
}
